const Data = [
    {
        "role":"MERN Stack Developer",
        "Location":"WFH",
        "start_Date":"August 2025",
        "end_Date":"present",
        "company_name":"Vikareta",
        "work":[
            "Designed and developed fully responsive, production-ready web applications using React, Redux, and Material-UI (MUI), ensuring seamless functionality across all devices and screen sizes",
            "Leveraged GitHub for version control and collaborative development workflows, implementing branching strategies and code reviews to maintain code quality and team coordination",
            "Implemented industry best practices by architecting and maintaining separate development, staging, and production environments with comprehensive lint rules (ESLint) to enforce code standards and prevent bugs",
            "Optimized application performance and scalability by managing complex application state with Redux, reducing unnecessary re-renders and improving data flow efficiency across large-scale applications",
            "Collaborated with UI/UX design teams to transform wireframes and design mockups into pixel-perfect, functional web interfaces that enhanced user experience and met business requirements",
            "Built and documented a comprehensive library of reusable React components with proper prop validation and TypeScript support, increasing development velocity and ensuring consistency across multiple projects"
            ]
}
]

export default Data
